import { AnyComponent, RenderableProps } from 'preact'

// [Preact X] Change AnyComponent to ComponentType

type Composer = <P>(
  Component: AnyComponent<P>,
  name: string,
  props: RenderableProps<P>,
  wrapper?: keyof JSX.IntrinsicElements
) => JSX.Element

const ClientComponent: Composer = function (Component, name, props, Wrapper = 'div') {
  return (
    <Wrapper data-preact={name} data-props={JSON.stringify(props)}>
      <Component {...props} />
    </Wrapper>
  )
}

export default ClientComponent
